export default __webpack_public_path__ + "static/media/background_start.74a88175.jpg";